import { colorMiscGray80 } from "@rhumbix/rmbx_design_system_web"
import { ICellRendererParams } from "ag-grid-community"
import { EOD_QUESTION_ICONS } from "../../../forms/EodQuestionForm/iconOptions"
import { EodQuestionRowData } from "../../../forms/EodQuestionForm/types"

/** Renders the icon (if any) chosen for an EodQuestion row in the settings library grid. */
const EodQuestionIconCellRenderer = (params: ICellRendererParams): JSX.Element | null => {
    const icon = (params.data as EodQuestionRowData | undefined)?.icon
    if (!icon) return null

    const Icon = EOD_QUESTION_ICONS[icon]
    if (!Icon) return null

    return <Icon height={20} width={20} color={colorMiscGray80} />
}

export default EodQuestionIconCellRenderer
